function Footer() {
  return (
    <footer className="footer">
      <h3> Tiny Toes Preschool</h3>

      <p>
        Small Steps Big Dreams
      </p>

      <p>
        © 2026 Tiny Toes Preschool
      </p>
    </footer>
  );
}

export default Footer;